import FrontendJobModel from '@/common/models/jobs/frontend-job-model';
import JobModel from '@/common/models/jobs/job-model';
import TransactionModel from '@/common/models/transaction-model';
import timezone from '@/common/timezone';

export default class BatchRefundJobModel extends FrontendJobModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {processedOn = null} = fields;
        this.type = JobModel.Types.batchRefund;
        this.icon = 'data-exports';
        this.processedOn = processedOn ? timezone.readUTC(processedOn) : timezone.now();
    }

    get jobTime() {
        return this.processedOn;
    }

    // Summary of the job for display in the alerts-menu
    get label() {
        return `Batch Refund for ${this.items.length} item${this.items.length === 1 ? '' : 's'}`;
    }

    // Toast message to be displayed on completion of the job
    get toastMessage() {
        const failText = this.failedItems.length
            ? `Refund failed for ${this.failedItems.length} transaction${this.failedItems.length === 1 ? '' : 's'}.`
            : '';
        const successText = this.completedItems.length
            ? `${this.completedItems.length} transaction${this.completedItems.length === 1 ? '' : 's'} refunded successfully.`
            : '';
        const invalidText = this.invalidItems.length
            ? `${this.invalidItems.length} transaction${this.invalidItems.length === 1 ? '' : 's'} ineligible for refund.`
            : '';

        const text = ['Batch refund finished.', successText, failText, invalidText].join(' ');
        let type = 'warning';
        if (this.completedItems.length && !this.failedItems.length) {
            type = 'positive';
        } else if (!this.completedItems.length && this.failedItems.length) {
            type = 'negative';
        }

        return {
            type,
            text,
        };
    }

    async performAction({id}) {
        try {
            const {fields: {result}} = await this
                .api(({transactions}) => transactions.refund({id}));
            return result === 'approved';
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    async verifyItemStatus() {
        const ids = this.items.map(({id}) => id);
        const filter = `id:${ids.join(',')}`;
        const {items} = await this.api(({transactions}) => transactions.getAll({filter}));
        const transactions = items.map(item => new TransactionModel(item.fields));
        transactions.forEach((transaction) => {
            const itemToUpdate = this.items.find(item => item.id === transaction.id);
            if (!transaction.canRefund) {
                itemToUpdate.status = FrontendJobModel.ItemStatuses.invalid;
            } else if (!transaction.isRefunded) {
                itemToUpdate.status = FrontendJobModel.ItemStatuses.pending;
            } else {
                itemToUpdate.status = FrontendJobModel.ItemStatuses.completed;
            }
        });
    }

    getPayload() {
        return {
            ...super.getPayload(),
            icon: this.icon,
            processedOn: this.processedOn,
        };
    }
}
